import React, { useEffect, useRef, useImperativeHandle, forwardRef } from 'react';
import { Html5Qrcode } from 'html5-qrcode';
import Quagga from "quagga";
const decodeBarcodeFromImage = (imageDataUrl) =>
  new Promise((resolve) => {
    Quagga.decodeSingle(
      {
        src: imageDataUrl,
        numOfWorkers: 0,
        inputStream: { size: 800 },
        decoder: {
          readers: [
            "ean_reader",
            "ean_8_reader",
            "upc_reader",
            "upc_e_reader",
            "code_128_reader",
          ],
        },
      },
      (result) => {
        if (result?.codeResult?.code) {
          resolve({
            code: result.codeResult.code,
            format: result.codeResult.format,
          });
        } else {
          resolve(null);
        }
      }
    );
  });

const CameraScan = forwardRef(({ onDetected }, ref) => {
  const qrRegionId = 'qr-reader';
  const scannerRef = useRef(null);
  const scannerRunningRef = useRef(false);
  const lastScanTimeRef = useRef(0);
  const lastScannedCodeRef = useRef('');
  const isUnmountedRef = useRef(false);
const barcodeCooldownRef = useRef(0);
const BARCODE_COOLDOWN_MS = 800;

  const SCAN_COOLDOWN_MS = 1000;

useImperativeHandle(ref, () => ({
  stopScanner: async () => {
    if (scannerRef.current && scannerRunningRef.current) {
      try {
        await scannerRef.current.stop();
        await scannerRef.current.clear();
        scannerRunningRef.current = false;
      } catch (err) {
        console.error('Error stopping scanner:', err);
      }
    }
  },
  startScanner: async () => {
    if (!scannerRef.current || scannerRunningRef.current) return;

    try {
      await scannerRef.current.start(
        { facingMode: { exact: "environment" } },
        { fps: 10, qrbox: { width: 250, height: 250 } },
        (decodedText) => {
          const decoded = decodedText.trim().toUpperCase();
          const now = Date.now();

          if (
            decoded === lastScannedCodeRef.current &&
            now - lastScanTimeRef.current < SCAN_COOLDOWN_MS
          ) {
            return;
          }

          lastScannedCodeRef.current = decoded;
          lastScanTimeRef.current = now;

          onDetected(decoded);
        },
        (err) => {
          console.warn("Scan error:", err);
        }
      );
      scannerRunningRef.current = true;
    } catch (err) {
      console.error('Failed to restart scanner:', err);
    }
  }
}));


  useEffect(() => {
    const startScanner = async () => {
      if (!document.getElementById(qrRegionId)) {
        console.warn('QR region not found in DOM yet.');
        return;
      }

      scannerRef.current = new Html5Qrcode(qrRegionId);

      try {
        await scannerRef.current.start(
          { facingMode: { exact: 'environment' } },
          { fps: 10, qrbox: { width: 250, height: 250 } },
          (decodedText) => {
            const decoded = decodedText.trim().toUpperCase();
            const now = Date.now();

            if (
              decoded === lastScannedCodeRef.current &&
              now - lastScanTimeRef.current < SCAN_COOLDOWN_MS
            ) {
              return;
            }

            lastScannedCodeRef.current = decoded;
            lastScanTimeRef.current = now;

            onDetected(decoded);
          },
(err) => {
  if (isUnmountedRef.current) return;

  const now = Date.now();
  if (now - barcodeCooldownRef.current < BARCODE_COOLDOWN_MS) return;
  barcodeCooldownRef.current = now;

  const canvas = document.querySelector(`#${qrRegionId} canvas`);
  if (!canvas) return;

  const imageDataUrl = canvas.toDataURL("image/png");
  decodeBarcodeFromImage(imageDataUrl).then((barcode) => {
    if (!barcode) return;

    const detected = barcode.code.trim().toUpperCase();

    if (
      detected === lastScannedCodeRef.current &&
      now - lastScanTimeRef.current < SCAN_COOLDOWN_MS
    ) {
      return;
    }

    lastScannedCodeRef.current = detected;
    lastScanTimeRef.current = now;

    onDetected(detected, barcode.format);
  });
}

        );
        scannerRunningRef.current = true;
      } catch (err) {
        console.warn('Default camera failed, attempting fallback.', err);

        try {
          const devices = await Html5Qrcode.getCameras();
          if (!devices || devices.length === 0) {
            console.error('No camera devices found.');
            return;
          }

          const fallbackId = devices[0].id;

          await scannerRef.current.start(
            fallbackId,
            { fps: 10, qrbox: { width: 250, height: 250 } },
            (decodedText) => {
              const decoded = decodedText.trim().toUpperCase();
              const now = Date.now();

              if (
                decoded === lastScannedCodeRef.current &&
                now - lastScanTimeRef.current < SCAN_COOLDOWN_MS
              ) {
                return;
              }

              lastScannedCodeRef.current = decoded;
              lastScanTimeRef.current = now;

              onDetected(decoded);
            },
(err) => {
  if (isUnmountedRef.current) return;

  const now = Date.now();
  if (now - barcodeCooldownRef.current < BARCODE_COOLDOWN_MS) return;
  barcodeCooldownRef.current = now;

  const canvas = document.querySelector(`#${qrRegionId} canvas`);
  if (!canvas) return;

  const imageDataUrl = canvas.toDataURL("image/png");
  decodeBarcodeFromImage(imageDataUrl).then((barcode) => {
    if (!barcode) return;

    const detected = barcode.code.trim().toUpperCase();

    if (
      detected === lastScannedCodeRef.current &&
      now - lastScanTimeRef.current < SCAN_COOLDOWN_MS
    ) {
      return;
    }

    lastScannedCodeRef.current = detected;
    lastScanTimeRef.current = now;

    onDetected(detected, barcode.format);
  });
}

          );

          scannerRunningRef.current = true;
        } catch (fallbackErr) {
          console.error('Fallback camera start failed:', fallbackErr);
        }
      }
    };

    // Delay scanner start slightly to ensure DOM is ready
    const timeoutId = setTimeout(() => {
      startScanner();
    }, 300); // Slight delay for tablet DOM rendering

    return () => {
      isUnmountedRef.current = true;
      clearTimeout(timeoutId);
      if (scannerRef.current && scannerRunningRef.current) {
        scannerRef.current
          .stop()
          .then(() => {
            scannerRef.current.clear();
            scannerRunningRef.current = false;
          })
          .catch((err) => {
            console.error('Failed to stop scanner cleanly:', err);
          });
      }
    };
  }, [onDetected]);

return (
  <div style={{ width: '100%', maxWidth: 400, marginTop: '1rem', margin: '1rem auto 0' }}>
    <div id={qrRegionId} style={{ width: '100%' }} />
  </div>
);
});

export default React.memo(CameraScan);
